window.$ = jQuery;
import viewportHelper from "./utils/viewportHelper";
import { Application } from "@hotwired/stimulus";

import Menu from "./component/header/menu";
import Header from "./component/header/header";

import DataGalaxy from "./component/footer/datagalaxy";

import Logo3D from "./component/common/logo3d";
import HoverImage from "./component/common/hoverImage";
import OpenPopinIframe from "./component/common/openPopinIframe";
import PopinIframe from "./component/common/popinIframe";

import HomeExpertises from "./component/home/homeExpertises";
import HomeProjects from "./component/home/homeProjects";

import CmsLogosClients from "./component/gutenberg/cmsLogosClients";
import CmsNews from "./component/gutenberg/cmsNews";
import CmsSocialMediaImages from "./component/gutenberg/cmsSocialMediaImages";
import CmsImagesSlider from "./component/gutenberg/cmsImagesSlider";
import CmsAccordions from "./component/gutenberg/cmsAccordions";
import CmsUseCasesSlider from "./component/gutenberg/cmsUseCasesSlider";

import SingleResume from "./component/single/singleResume";
import Halo from "./component/common/halo";
import FlashNews from "./component/common/flashNews";

window.Stimulus = Application.start()
Stimulus.register("menu", Menu);
Stimulus.register("header", Header);
Stimulus.register("logo3d", Logo3D);
Stimulus.register("datagalaxy", DataGalaxy);

Stimulus.register("hover-image", HoverImage);
Stimulus.register("popiniframe", PopinIframe);
Stimulus.register("open-popiniframe", OpenPopinIframe);

Stimulus.register("home-expertises", HomeExpertises);
Stimulus.register("home-projects", HomeProjects);

Stimulus.register("cms-logos-clients", CmsLogosClients);
Stimulus.register("cms-news", CmsNews);
Stimulus.register("cms-social-media-images", CmsSocialMediaImages);
Stimulus.register("cms-images-slider", CmsImagesSlider);
Stimulus.register("cms-accordions", CmsAccordions);
Stimulus.register("cms-use-cases-slider", CmsUseCasesSlider);

Stimulus.register("single-resume", SingleResume);
Stimulus.register("halo", Halo);

Stimulus.register("flash-news", FlashNews);


document.addEventListener('DOMContentLoaded', () => {
    viewportHelper.init();
});

document.addEventListener('click', function(e) {
    const el = e.target.closest('[data-ofsq]');
    if (!el) return;
    e.preventDefault();
    const url = atob(el.dataset.ofsq);
    if(url) window.location.href = url;
});
